/*
* Contains all the components for displaying and changing payment plans
List of possible payment plans are in the FAQ.md
*/

import * as React from "react";
import constants from "../../constants";
import { GFUser, GFPlan, GFInitialState } from "../../models/models";
import { connect } from "react-redux";
import {
  manualAjaxEnd,
  manualAjaxStart,
} from "../../actions/ajaxStatusActions";
import VerificationAlert from "../common/VerificationAlert";
import { Button } from "react-bootstrap";
import { browserHistory } from "react-router";
import {
  couponCheck,
  updateCard,
} from "../../actions/paymentActions";
import {
  Grid,
  Row,
  Col,
  ListGroup,
  ListGroupItem,
  Modal,
  FormGroup,
  FormControl,
} from "react-bootstrap";
import UpdateCardSection from "../payment/UpdateCardSection";
import { ManageAccountButtons } from "../payment/ManageAccountButtons";
import { selectIsTeacher, selectHasGoogleClasses } from "../../reducers/userReducer";
import { Stripe, StripeElements } from "@stripe/stripe-js";
import DirectCheckoutModal from "./DirectCheckoutModal";
import { find } from "lodash";
import PlanSelector from './../payment/PlanSelector';
import utils from './../payment/utils';
import resolveDomain from '../../resolve-domain';
import AvailableContentLeft from '../payment/AvailableContentLeft';
import AvailableContentRight from '../payment/AvailableContentRight';

const graham = require("../../images/graham.gif");
const masterGraham = require("../../images/diploma.png");
interface Props extends React.Props<DirectCheckout> {
  user: GFUser;
  loading: boolean;
  updateCard: (paymentToken: string) => Promise<void>;
  manualAjaxEnd: any;
  manualAjaxStart: any;
  hasGoogleClasses: boolean;
  isTeacher: boolean;
  stripe: Stripe;
  elements: StripeElements;
  location: any;
  utm_source: string;
  utm_medium: string;
  utm_campaign: string;
  utm_content: string;
  utm_term: string;
  gclid: string;
}

interface State {
  planRecurringType: string;
  StripeKey: string;
  newPaymentPlan: string;
  paymentPlanStudents: number;
  showPaymentModal: boolean;
  masterButton: string;
  showCreditCardModal: boolean;
  selectedPlan: GFPlan;
}

class DirectCheckout extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      planRecurringType: "Annual",
      StripeKey: resolveDomain().stripe,
      newPaymentPlan: "",
      paymentPlanStudents: 25,
      showPaymentModal: false,
      masterButton: "",
      showCreditCardModal: false,
      selectedPlan: { ...constants.paymentPlanObjectsByID.masterAnnual_3 },
    };
  }
  componentDidMount(){
    // If we don't have a user here, we go back to /register
    if(!this.props.user){
      browserHistory.push("/register")
    }
  }

  openUpdateCreditCard = () => {
    this.setState({ showCreditCardModal: true });
  };

  closeUpdateCreditCard = () => {
    this.setState({ showCreditCardModal: false });
  };

  closePaymentModal = () => {
    this.setState({ showPaymentModal: false });
  };

  openPaymentModal = () => {
      this.setState({ showPaymentModal: true });
  };
  handleChange = (e: any) => {
    if (e) {
      e.preventDefault();
    }
    const targetName = e.currentTarget.name;
    this.setState({ [targetName]: e.currentTarget.value } as unknown as State, () => {
      this.updateSelectedPaymentPlan();
    });
  };

  togglePlanRecurringType = () => {
    this.setState(
      { planRecurringType: this.state.planRecurringType === "Annual" ? "Monthly" : "Annual" },
      () => {
        this.updateSelectedPaymentPlan();
      }
    );
  };

  /*
   * Update Credit Card Modal
   */
  updateCreditCardModal = () => {
    return (
      <Modal
        show={this.state.showCreditCardModal}
        onHide={this.closeUpdateCreditCard}
      >
        <Modal.Header closeButton={true}>
          <Modal.Title>Update Credit Card</Modal.Title>
        </Modal.Header>
        <UpdateCardSection
          user={this.props.user}
          loading={this.props.loading}
          show={this.state.showCreditCardModal}
          hide={this.closeUpdateCreditCard}
          updateCard={this.props.updateCard}
          manualAjaxStart={this.props.manualAjaxStart}
          manualAjaxEnd={this.props.manualAjaxEnd}
          stripe={this.props.stripe}
          elements={this.props.elements}
        />
      </Modal>
    );
  };

  /*
   * updateSelectedPaymentPlan
   * figure out the selectedPayment plan and set it to state
   */
  updateSelectedPaymentPlan = () => {
    const selectedPlan = utils.selectPaymentPlan(this.state.planRecurringType, this.state.paymentPlanStudents);

    this.setState({
      selectedPlan: selectedPlan.plan,
      planRecurringType: selectedPlan.plan.time,
    });
  };

  isHomeschoolMonthly = () => {
    return false;
  };

  render() {
    const { isTeacher, user } = this.props;

    let amountOfStudents = this.state.selectedPlan.size * this.state.selectedPlan.quantity;

    if(!user){
      return null;
    }

    return (
      <div>
        <Grid className="content modal-container">
          <div className="main-content direct-payment">
            <VerificationAlert user={this.props.user} isTeacher={isTeacher} />
            <Row>
              <Col md={12} xs={12}>
                <div className="payment-header">
                  <h1>Payment and Plans</h1>
                </div>
              </Col>
            </Row>
            <Row className="display-payment-options">
              {/*
               * Display Payment Modal
               */}
              <DirectCheckoutModal
                show={this.state.showPaymentModal}
                stripe={this.props.stripe}
                selectedPlan={this.state.selectedPlan}
                hide={this.closePaymentModal}
                elements={this.props.elements}
                togglePlanRecurringType={this.togglePlanRecurringType}
                user={this.props.user}
                utm_source={this.props.utm_source}
                utm_medium={this.props.utm_medium}
                utm_campaign={this.props.utm_campaign}
                utm_content={this.props.utm_content}
                utm_term={this.props.utm_term}
                gclid={this.props.gclid}
              />
              {/*
               * Display Update Credit Card Modal
               */
              this.updateCreditCardModal()}

              <Col md={5} xs={5} style={{ padding: 0 }}>
                <div className="payment-col-1">
                  <div className="top-box">
                    <PlanSelector
                      handleChange={this.handleChange}
                      paymentPlanStudents={this.state.paymentPlanStudents}
                      planRecurringType={this.state.planRecurringType}
                      selectedPlan={this.state.selectedPlan}
                      loading={this.props.loading}
                    />
                    <ManageAccountButtons
                      hasSubscription={false}
                      openUpdateCreditCard={this.openUpdateCreditCard}
                      showConfirmationModal={() => {}}
                      openPaymentModal={this.openPaymentModal}
                      isPurchaseOrder={false}
                    />
                  </div>
                  {this.isHomeschoolMonthly() === false && (
                    <AvailableContentLeft/>
                  )}
                </div>
              </Col>
              <Col md={7} xs={7} style={{ padding: 0 }}>
                {this.isHomeschoolMonthly() && (
                  <h3 style={{ padding: "20px" }}>
                    Homeschool plans are annual only.  Please select annual.
                  </h3>
                )}
                {this.isHomeschoolMonthly() === false && (
                  <div className="payment-col-2">
                    <div className="top-box">
                      <Row>
                        <img alt="master graham" src={masterGraham} />
                      </Row>
                      <Row>
                        <h1 className="col-2">GrammarFlip Subscription</h1>
                        <h5 className="display-amount-of-students">
                          {amountOfStudents} Students
                        </h5>
                        <h3 style={{ fontWeight: 600, marginTop: "10px" }}>
                          ${utils.totalPrice(this.state.selectedPlan)} /
                          {this.state.planRecurringType}
                        </h3>
                      </Row>
                      <Row className="payment-button">
                        <div>
                        <Button
                          onClick={() => this.openPaymentModal()}
                          disabled={this.props.loading}
                        >
                          Sign Me Up!
                        </Button>
                      </div>
                      </Row>
                    </div>
                    <AvailableContentRight/>
                  </div>
                )}
              </Col>
            </Row>
          </div>
        </Grid>
      </div>
    );
  }
}
const mapStateToProps = (state: GFInitialState, ownProps: any) => {
  const location = browserHistory.getCurrentLocation();
  const { utm_source, utm_medium, utm_campaign, utm_content, utm_term, gclid } = location.state;
  return {
    user: location.state,
    utm_source: utm_source,
    utm_medium: utm_medium,
    utm_campaign: utm_campaign,
    utm_content: utm_content,
    utm_term: utm_term,
    gclid: gclid,
    loading: state.ajaxCallsInProgress > 0,
    isTeacher: selectIsTeacher(state),
    hasGoogleClasses: selectHasGoogleClasses(state),
  };
};

const myCheckoutForm = connect(mapStateToProps, {
  couponCheck,
  updateCard,
  manualAjaxEnd,
  manualAjaxStart,
})(DirectCheckout);
// export default injectStripe(myCheckoutForm);
export default myCheckoutForm;
